import { useTranslation } from "react-i18next"

import { useGetCertificatesFiltersOptions } from "~/pages/Brand/Certificates/hooks/useGetCertificatesFiltersOptions"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const useBuildCertificatesFilters = () => {
  const { t } = useTranslation(["certificates"])
  const { filters, setFilters } = useCertificatesTableContext()

  const options = useGetCertificatesFiltersOptions()

  return {
    filters,
    setFilters,
    options,
    title: t("filters.title"),
    searchPlaceholder: t("filters.search.placeholder"),
  }
}
